import { render, staticRenderFns } from "./StarBorder.vue?vue&type=template&id=64af7e02&scoped=true"
import script from "./StarBorder.vue?vue&type=script&lang=js"
export * from "./StarBorder.vue?vue&type=script&lang=js"
import style0 from "./StarBorder.vue?vue&type=style&index=0&id=64af7e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af7e02",
  null
  
)

export default component.exports